module.exports = __webpack_public_path__ + "static/media/Chris Nussman Headshot_1648181936786.2d73e248.png";